/**
 * @prettier
 * @flow
 */
import * as React from 'react';
import { FormSelect } from 'src/components/form/FormSelect';
import type { Variant } from 'src/components/form/FormTypes';
import { Environments } from 'src/constants/Environment';
import { translate } from 'src/utils/translate/translate';

export function FormEnvironmentSelect({ name, label, placeholder, helperText, defaultValue, disabled, required, variant = 'outlined', onChange }: Props) {
    let options = required
        ? Object.values(Environments).map((city: any) => ({ label: translate(city), value: city }))
        : [{ label: '', value: null }, ...Object.values(Environments).map((city: any) => ({ label: translate(city), value: city }))];
    return (
        <FormSelect
            name={name}
            label={label}
            placeholder={placeholder}
            helperText={helperText}
            defaultValue={defaultValue}
            options={options}
            disabled={disabled}
            required={required}
            variant={variant}
            onChange={onChange}
        />
    );
}

type Props = {|
    name: string,
    label?: string,
    placeholder?: string,
    helperText?: string,
    defaultValue?: string,
    disabled?: boolean,
    required?: boolean | { value: number, message: string },
    variant?: Variant,
    onChange?: Function,
|};
